<template>
  <div class="certification">
    <div class="flex items-center justify-center header">
      <p class="mt-20 text-white text-font-32 font-weight-bold"></p>
    </div>
    <div class="pb-5 mx-auto body" v-loading="loading">
      <div class="video" v-for="(item, index) in videoList" :key="index">
        <div class="video_bg">
          <img class="big" :src="item.cover_url" />
          <div class="shadess"></div>
          <img class="stop" @click="showCurrentVideo(item.id, item.video_url)" src="@/assets/images/stop1.png" />
        </div>
      </div>
      <div style="text-align:center">
        <el-pagination background :current-page.sync="paging.page" :page-size.sync="paging.size" :total="paging.total"
          layout="prev, pager, next" @current-change="load" @size-change="load">
        </el-pagination>
      </div>
    </div>
    <div class="mask-layer" v-if="showPopup">
      <div class="shade"></div>

      <div class="playContent">
        <video-player ref="videoPlayer" :options="playerOptions" class="video-player"></video-player>
        <div class="close1" @click="showPopup = false">
          <img src="@/assets/images/video_close3.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategory, videoList, viewVideoCount } from '@/api'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  components: {
    videoPlayer
  },

  data() {
    let self = this
    return {
      dialogVisible: false,
      list: [],
      paging: {
        page: 1,
        size: 5,
        total: 0
      },
      loading: false,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 10,
        loop: true,
        lazy: true,
        slidesPerGroup: 4,
        videoUrl: '',
        autoplay: {
          delay: 8000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
      },
      videoList: [],
      showPopup: false,
      playerOptions: {},
      ViewerOptions: {
        viewed(e) {
          this.swiper.autoplay.stop()
        },
        hide() {
          this.swiper.autoplay.start()
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    // window.addEventListener('contextmenu', e => e.preventDefault())
    getCategory(null, 8).then(ret => {
      if (ret.result) {
        this.list = ret.result.map(c => {
          return {
            image: c.bg.md,
            name: c.name,
            title: c.title.zh,
            desc: c.content.zh
          }
        })
      }
    })
    this.load()
  },

  methods: {
    load() {
      this.loading = true
      this.videoList = []
      videoList({
        page: this.paging.page,
        size: this.paging.size,
        status: [2]
      }).then(ret => {
        this.loading = false
        this.videoList = ret.gallery_list
        this.paging.total = ret.total
      })
    },
    goNext() {
      this.swiper.slideNext()
    },
    goPrev() {
      this.swiper.slidePrev()
    },
    showCurrentVideo(id, item) {
      viewVideoCount(id)
      this.playerOptions = {
        fluid: true,
        autoplay: true,
        loop: true,
        // videojs options
        sources: [
          {
            src: item
          }
        ]
      }
      this.$nextTick(() => {
        this.showPopup = true
      })
    }
  }
}
</script>

<style lang="less">
@slideHeight: 60vh;

.certification {
  background-color: white;

  img {
    max-width: 100%;
    height: auto;
  }

  min-width: 1200px;
  margin: auto;

  .header {
    width: 100%;
    height: 200px;
    background: url('../../assets/images/company-profile/顶部图片.jpg');
    background-size: contain;
    background-position: center;
  }

  .mask-layer {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .shade {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 2;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .playContent {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
      width: 60vw;
      height: 33.75vw;

      // overflow: hidden;
      .video-player {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }

      .close1 {
        position: absolute;
        right: -20px;
        top: -20px;
        width: 40px;
        height: 40px;
        cursor: pointer;
        transition: all 0.4s;
        z-index: 9999;
        font-size: 0;
      }
    }
  }

  .body {
    width: 85vw;
    margin-top: 10vh;

    .video {
      font-size: 0;
      margin-bottom: 16px;
      width: 100%;

      .video_bg {
        position: relative;
        cursor: pointer;
        width: 100%;

        &:hover {
          .shadess {
            background-color: rgba(0, 0, 0, 0.4);
          }

          .stop {
            opacity: 1;
          }
        }

        .big {
          width: 100%;
          vertical-align: middle;
        }

        .shadess {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
          transition: all 0.5s;
        }

        .stop {
          width: 60px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          opacity: 0;
          transition: all 0.5s;
        }
      }
    }
  }
}
</style>
